import { useLanguage } from '@/contexts/LanguageContext';

const SkipToContent = () => {
  const { isRTL } = useLanguage();

  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:start-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-lg focus:text-sm focus:font-medium focus:shadow-lg focus:outline-none"
    >
      {isRTL ? 'انتقل إلى المحتوى الرئيسي' : 'Skip to main content'}
    </a>
  );
};

export default SkipToContent;
